import { createSlice } from "@reduxjs/toolkit";
export const ForgotPswdCounterSlice = createSlice({
  name: "ForgotPswdCounter",
  initialState: {
    ForgotPswdCounter: 0,
  },
  reducers: {
    getForgotPswdCounter: (state, action) => {
      state.ForgotPswdCounter = parseInt(action.payload);
    },
  },
});

export const { getForgotPswdCounter } = ForgotPswdCounterSlice.actions;

export default ForgotPswdCounterSlice.reducer;
